// Intercepts clicks that land on the card's whole-card "view product" link
// but geometrically overlap the Quick Add button, and redirects them to the
// button instead. Belt-and-suspenders CSS stacking fixes (sibling placement,
// isolation) didn't reliably win the browser's native hit-test in testing,
// so this checks click coordinates directly rather than relying on it.
document.addEventListener(
  'click',
  (event) => {
    const cardWrapper = event.target.closest('.card-wrapper');
    if (!cardWrapper) return;

    const trigger = cardWrapper.querySelector('.quick-add--card');
    if (!trigger || trigger.contains(event.target)) return;

    const rect = trigger.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return;

    const withinBounds =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
    if (!withinBounds) return;

    event.preventDefault();
    event.stopPropagation();
    trigger.querySelector('button')?.click();
  },
  true
);
